/** Identity-broker determine-login is disabled on Kinde-forced builds only. */
export function isDetermineLoginAllowed(): boolean {
  return process.env.NEXT_PUBLIC_FORCE_KINDE !== 'true';
}
